import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { EmployeePaths } from 'src/components/AppRoutes/Enterprise/EmployeePaths';
import {
  EmployeeCreateRoute,
  EmployeeDetailsRoute,
  EmployeeEditRoute,
} from 'src/components/AppRoutes/EmployeeRoutes.layout';

export const EmployeeRoutes = (): JSX.Element | null => {
  return (
    <Switch>
      <Route
        exact
        path={EmployeePaths.create}
        component={EmployeeCreateRoute}
      />

      <Route exact path={EmployeePaths.edit} component={EmployeeEditRoute} />

      <Route
        exact
        path={EmployeePaths.details}
        component={EmployeeDetailsRoute}
      />
    </Switch>
  );
};
